import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';

import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';

const styles = theme => ({
    layoutRoot: {},
});

class StudentList extends Component {

    componentDidMount() {
        this.props.getStudentCourses(this.props.auth.user.data.role_info.link_id);
    }

    handleRowClick(course) {
        this.props.history.push(`/scheduled_course/detail/${course.company_calendar_course_id}`);
    }

    timeColumn = (timeValue) => {
        if (timeValue) {
            return moment(timeValue).format('YYYY-MM-DD')
        }
        else {
            return null
        }
    }

    selfPaced = (value) => {
        if (value === 1) {
            return <Icon>done</Icon>
        }
        return null
    }

    render() {
        const { classes, studentCourses, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Student Courses</h4></div>
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">

                    </div>
                }
                content={
                    <ReactTable
                        columns={[
                            {
                                Header: "Course Name",
                                accessor: "CourseName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.CourseName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Self-Paced",
                                accessor: a => this.selfPaced(a.Unscheduled),
                                id: "Self-Paced"
                            },
                            {
                                Header: "Start Date",
                                accessor: a => this.timeColumn(a.StartDate),
                                id: "StartDate"
                            },
                            {
                                Header: "End Date",
                                accessor: a => this.timeColumn(a.StartDate),
                                id: "EndDate"
                            },
                            {
                                Header: "",
                                Cell: row => (
                                    <div className="flex items-center">
                                        <IconButton
                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick(row.original);
                                            }}
                                        >
                                            <Icon>library_books</Icon>
                                        </IconButton>
                                    </div>
                                )
                            }
                        ]}
                        data={studentCourses}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Courses Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentCourses: Actions.getStudentCourses,
        setTableSort: TableActions.setTableSort,
        setTableFilter: TableActions.setTableFilter,
        resetTableFilter: TableActions.resetTableFilter,
        setTablePageSize: TableActions.setTablePageSize,
    }, dispatch);
}

function mapStateToProps({ studentApp, tableSort, auth }) {
    return {
        studentCourses: studentApp.students.courses,
        table_sort: tableSort.table_sort,
        table_filter: tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded: tableSort.is_loaded,
        auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentList)));


// WEBPACK FOOTER //
// src/main/content/student/StudentCourseList.js